module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.eb43b4c.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/font/Roboto-Bold.woff
// module id = u+zB
// module chunks = 0